import styled from "@emotion/styled";
import { CalendarGridHeader } from "react-aria-components";

export const StyledCalendarGridHeader = styled(CalendarGridHeader)``;
